import { DotLoaderWrap } from './ThreeDotLoader.styled';

export const ThreeDotLoader = () => {
  return <DotLoaderWrap>...</DotLoaderWrap>;
};
